// Oregon State's undergraduate majors (#2743). Read on 2026-10-01 from the
// official OSU Catalog's Degrees and Programs page (catalog.oregonstate.edu/
// programs), whose filters tag each program by type, level, location and
// college. Kept: every program tagged Major, Undergraduate and Corvallis,
// under each college it is tagged with (Forest Engineering - Civil
// Engineering is tagged with both Engineering and Forestry). Left out:
// minors, options, certificates, graduate programs, the Honors College's
// Honors Scholar tracks (not majors) and 11 majors offered only at
// OSU-Cascades or through Ecampus (American Studies, Applied Humanities,
// Arts, Media, and Technology, Contemporary Music Industry, Early Childhood
// Leadership, Policy, and Practice, Energy Systems Engineering, Engineering
// Science, Healthcare Administration, Hospitality Management, Outdoor
// Products, Social Science). Degrees are the catalog's own, with the honors
// versions (HBA, HBS, HBFA, HBM) dropped. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "oregon-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major Oregon State's official catalog offers on the Corvallis campus, grouped by the college that offers it, with the degrees it leads to. Minors, options, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural Sciences",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Agricultural and Food Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural and Natural Resources Communication",
                    "degree": "BA, BS"
                },
                {
                    "name": "Agricultural Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Bioresource Research",
                    "degree": "BS"
                },
                {
                    "name": "Botany",
                    "degree": "BS"
                },
                {
                    "name": "Crop and Soil Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Economics and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Fisheries, Wildlife, and Conservation Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Food Science and Sustainable Technologies",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Rangeland Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Apparel Design",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BA, BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Business Information Systems",
                    "degree": "BA, BS"
                },
                {
                    "name": "Design and Innovation Management",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BA, BS"
                },
                {
                    "name": "Innovation & Entrepreneurship",
                    "degree": "BA, BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BA, BS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BA, BS"
                },
                {
                    "name": "Product and Merchandising Management",
                    "degree": "BS"
                },
                {
                    "name": "Sports Business",
                    "degree": "BA, BS"
                },
                {
                    "name": "Supply Chain and Logistics Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Earth, Ocean, and Atmospheric Sciences",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Climate Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Geography and Geospatial Science",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Oceanography",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "BA, BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architectural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Construction Engineering Management",
                    "degree": "BA, BS"
                },
                {
                    "name": "Ecological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Forest Engineering - Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Science and Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Forestry",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Forest Engineering - Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Forest Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Forestry",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources",
                    "degree": "BS"
                },
                {
                    "name": "Tourism, Recreation, and Adventure Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Wood Innovation for Sustainability",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Human Development and Family Sciences",
                    "degree": "BA, BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Art",
                    "degree": "BA, BFA, BS"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Digital Communication Arts",
                    "degree": "BA, BFA, BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA, BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA, BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "History",
                    "degree": "BA, BS"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Marine Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Music Studies",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BA, BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA, BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA, BS"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Oregon State University Catalog, Degrees and Programs",
                "url": "https://catalog.oregonstate.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biochemistry and Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "BioHealth Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
